import React from "react";
import { observer } from "mobx-react";
import styles from "./CookieConsentBanner.scss";
import { HtmlContent } from "../HtmlContent/HtmlContent";
import { Button } from "../Button/Button";
import { useStores } from "netbank-shared/src/hooks";

interface ICookieConsentBannerProps {
  cookieConsentText: string;
  acceptButtonText: string;
}

export const CookieConsentBanner = observer(({ cookieConsentText, acceptButtonText }: ICookieConsentBannerProps) => {
  const { uiStore, globalPersistentStore } = useStores();

  if (globalPersistentStore.cookiesAccepted) return null;
  return (
    <>
      <div className={styles.overlay} />
      <div className={styles.banner}>
        <HtmlContent html={cookieConsentText} />
        <Button title={acceptButtonText} fullWidth={uiStore.isSm} centered color="primary" onClick={() => globalPersistentStore.setCookiesAccepted(true)} />
      </div>
    </>
  );
});
